import { derived, writable } from "svelte/store";

export let subscriberTableFilter = writable({
    page: 1,
    size: 50
});

export let renewSubscriberPromise = writable(null);

export let isCreateSubscriberModalClosable = derived(renewSubscriberPromise, ($renewSubscriberPromise) => {
  return $renewSubscriberPromise === null;
});